import { ACTIONABLE_ITEM_TYPES } from '@lumapps/ask-ai/types';
import { lumappsMicroApp } from '@lumapps/lumx/custom-icons';
import { mdiAccountCircle } from '@lumapps/lumx/icons';
import { GLOBAL } from '@lumapps/translations';

import { ASK_AI_RULES } from './keys';
import { ActionableItemListItem } from './types';

/** Ask AI rules scope to use for tracking */
export const SCOPE = 'ask-ai-rules';

/** Max ask ai rules fetched by pages */
export const RULES_LIST_MAX_RESULTS = 20;

/** Maximum amount of external sources per rule */
export const MAX_EXTERNAL_SOURCES = 4;

/** ask ai default sort option */
export const DEFAULT_SORT_ORDER = '-updatedAt,title';

export const actionableItemList: ActionableItemListItem[] = [
    { label: GLOBAL.MICRO_APP, icon: lumappsMicroApp, value: ACTIONABLE_ITEM_TYPES.MICRO_APP },
    { label: ASK_AI_RULES.CUSTOM_RULE_USER_CARD_LABEL, icon: mdiAccountCircle, value: ACTIONABLE_ITEM_TYPES.USER_CARD },
];

export const ACTIONABLE_ITEM_NAME = 'actionableItem';
export const USER_FIELDS = ['jobTitle', 'location'];

export const LINK_TO_DOCUMENTATION =
    'https://docs.lumapps.com/docs/ls/content/7823233373331425/docs/knowledge-knowledge-management-landing/knowledge-l24941411133985458search/knowledge-l1561709127419536search/knowledge-l9230592387061355search';
